<template>
  <div class="comp-ly-col-more" :class="hasFilter ? 'comp-ly-col-filter' : data.visible ? 'comp-ly-col-visible' : 'comp-ly-col-no-visible'">
    <span class="table-title-custom-text">{{ props.fieldName }} </span>
    <template v-if="getIsNotSort()">
      <qfei-icon-descending-order-outlined class="sort-color" v-if="data.columnSort === false" style="margin-left: 8px"></qfei-icon-descending-order-outlined>
      <qfei-icon-ascending-order-outlined class="sort-color" v-if="data.columnSort === true" style="margin-left: 8px"></qfei-icon-ascending-order-outlined>
    </template>
    <jw-trigger :popup-visible="data.visible" class="fh-table-header-popup-confirm" trigger="click" unmount-on-close position="bottom" :popup-offset="12">
      <template #content>
        <div class="demo-basic">
          <jw-space direction="vertical" fill>
            <template v-if="!props.isSubForm">
              <template v-if="hasFrozen">
                <div class="col-more-title">冻结</div>
                <div @click="changeSwitch(!slotChecked)" :class="['cursor-item', slotChecked ? 'cursor-item-active' : '']">
                  <template v-if="slotChecked">
                    <icon-unlock />
                    {{ $t('取消冻结') }}
                  </template>
                  <template v-else>
                    <icon-lock />
                    {{ $t('冻结') }}
                  </template>
                </div>
              </template>
              <!-- <jw-divider v-if="showDivider" margin="0" /> -->

              <template v-if="getIsNotSort()">
                <div class="col-more-title">排序</div>
                <template v-if="props.col?.fieldType == 9">
                  <div class="sort-container">
                    <div @click.stop="sortChange(true, col, 'begin')" type="text" class="sort-item" :class="[getFieldsSort(col, true, 'begin') ? 'field-sort-selected' : 'field-sort-up']">
                      <qfei-icon-ascending-order-outlined class="sort-icon" />
                      开始时间升序
                    </div>
                    <div @click.stop="sortChange(false, col, 'begin')" type="text" class="sort-item" :class="[getFieldsSort(col, false, 'begin') ? 'field-sort-selected' : 'field-sort-up']"><qfei-icon-ascending-order-outlined class="sort-icon" />开始时间降序</div>
                    <div @click.stop="sortChange(true, col, 'end')" type="text" class="sort-item" :class="[getFieldsSort(col, true, 'end') ? 'field-sort-selected' : 'field-sort-up']"><qfei-icon-descending-order-outlined class="sort-icon" />结束时间升序</div>

                    <div @click.stop="sortChange(false, col, 'end')" type="text" class="sort-item" :class="[getFieldsSort(col, false, 'end') ? 'field-sort-selected' : 'field-sort-up']"><qfei-icon-descending-order-outlined class="sort-icon" />结束时间降序</div>
                  </div>
                </template>
                <template v-else>
                  <div class="sort-container">
                    <div @click="sortChange(true, props.col)" :class="['sort-item', data.columnSort === true ? 'field-sort-selected' : '']"><qfei-icon-ascending-order-outlined />{{ $t('升序') }}</div>
                    <div @click="sortChange(false, props.col)" :class="['sort-item', data.columnSort === false ? 'field-sort-selected' : '']"><qfei-icon-descending-order-outlined />{{ $t('降序') }}</div>
                  </div>
                </template>
              </template>
            </template>
            <template v-if="props.col?.colKey !== 'businessId'">
              <div :class="props.col?.fieldType === 9 ? 'date-range-box' : 'filter-condition-box'">
                <div class="col-more-title">排序</div>
                <div class="range-filter-box" v-if="props.col?.fieldType === 9">
                  <div v-for="item in dateRangeTypeList" :key="item.value" :class="['date-range-item', dateRangeType === item.value ? 'date-range-item-active' : '']" @click="handleChangeDateRangeType(item.value)">
                    {{ item.label }}
                  </div>
                </div>

                <jw-select v-if="props.col?.colKey === 'qccId' || props.col?.business?.fieldKey === 'qccId'" class="rule-form-item-sub-filter" v-model="conditionsItem.operation" :placeholder="$t('请选择')" :trigger-props="{ updateAtScroll: true }" @change="changeChildTwo($event)" allow-search allow-clear>
                  <jw-option v-for="item in data.qccID" :key="item.value" :value="item?.value">{{ item?.label }}</jw-option>
                </jw-select>
                <jw-select v-else class="rule-form-item-sub-filter" v-model="conditionsItem.operation" :placeholder="$t('请选择')" :trigger-props="{ updateAtScroll: true, contentClass: 'search-ultra-filter-select' }" @change="changeChildTwo($event, tools.isJSON(props.col?.fieldExt) && JSON.parse(props.col?.fieldExt)?.type)" allow-search allow-clear>
                  <!-- 条件选择--根据字段类型是24的特殊处理（根据fieldExt中的type再区分条件） -->
                  <template v-if="props.col?.fieldType === 24 || props.col?.business?.fieldType == 24">
                    <jw-option v-for="item in getConditionFilterType(props.col?.colKey)" :key="item.value" :value="item?.value">{{ item?.label }}</jw-option>
                  </template>
                  <template v-else>
                    <jw-option v-for="item in getOperation" :key="item.value" :value="item?.value">{{ item?.label }}</jw-option>
                    <!-- 特殊处理属于当前值 -->
                    <jw-option v-if="(props.col?.fieldType === 12 || props.col?.fieldType === 25) && props.col?.fieldExt == props.parentEntityId" :value="props.findAssociation.value">{{ props.findAssociation.label }}</jw-option>
                  </template>
                </jw-select>
              </div>
              <table-item-fliter v-if="conditionsItem.operation != 'null' && conditionsItem.operation != 'not_null' && conditionsItem.operation != 'equals_current_value'" :col="conditionsCol" :conditionsItem="conditionsItem" @cb="updateModulesItem" :dateRangeType="dateRangeType"></table-item-fliter>
            </template>
          </jw-space>
        </div>
      </template>
      <div class="table-title-custom-icon" ref="moreIconRef" @click="clickMoreIcon()">
        <icon-more v-show="!hasFilter" />
        <icon-filter v-show="hasFilter" />
      </div>
    </jw-trigger>
  </div>
</template>

<script setup>
import { QfeiIconAscendingOrderOutlined, QfeiIconDescendingOrderOutlined } from '@qfei-design/icons-vue';
import { constFieldSort } from '@/utils/const';
import { useFilterListStore } from '@/store';
import { computed, inject, reactive, ref, watch } from 'vue';
import { Message } from '@arco-design/web-vue';
import TableItemFliter from '@/components/customization/table-item-fliter/table-item-fliter.vue'; // 筛选条件
import { tools } from '@/utils/tools';
import md5 from 'js-md5';
import CONFIG from '@/config/config';
import { useI18n } from 'vue-i18n';
const useFilterList = useFilterListStore();
import _ from 'lodash';
const { t } = useI18n();
const props = defineProps({
  col: {
    type: Object,
    default: () => ({})
  },
  record: {
    type: Object,
    default: () => ({})
  },
  fieldName: {
    type: String,
    default: ''
  },
  viewId: {
    type: String
  },
  showColOverlay: {
    type: Boolean,
    default: false
  },
  colOverlayId: {
    type: String
  },
  cb: {
    type: Function
  },
  sortCb: {
    type: Function
  },
  getSearchDataCb: {
    type: Function
  },
  showLayCb: {
    // 控制父组件遮罩层
    type: Function
  },
  ruleForm: {
    type: Object,
    default: () => ({})
  },
  findAssociation: {
    type: Object,
    default: () => ({})
  },
  isSubForm: {
    type: Boolean,
    default: false
  },
  setting: {
    type: Object,
    default: () => ({})
  },
  hasFrozen: {
    type: Boolean,
    default: true
  },
  isAssociation: {
    type: Boolean,
    default: false
  }
});
const conditionsCol = ref(props?.col); // 列信息
const uuid = computed(() => props.viewId);
// const showDivider = computed(() => getIsNotSort() || props.hasFrozen);
const fieldSort = ref(props.record?.fieldSort);
const data = reactive({
  sortChangeData: {
    col: ''
  },
  visible: false,
  columns: inject('defaultParams')?.columns,
  columnSort: computed(() => fieldSort.value),
  isShow: false,
  ruleForm: {
    fieldKey: t('全部数据'), //数据条件
    leadsFieldList: [], //第一个
    objList: {}, //fieldKey：obj 类型
    filterType: {}, //中间
    isGroup: true,
    field: props.col.colKey,
    value: null,
    parentId: undefined,
    conditions: []
    //conditions: [{ id: undefined, operation: 'and', isGroup: true, parentId: undefined, children: [{ id: undefined, operation: '', isGroup: false, parentId: undefined, field: '', value: null }] }]
  },
  qccID: [
    {
      label: '为空',
      value: 'null',
      business: null,
      deleted: null
    },
    {
      label: '不为空',
      value: 'not_null',
      business: null,
      deleted: null
    }
  ],
  oldConditionsItem: ''
});
const cols = ref([]);
// 单个筛选项
const conditionsItem = ref({});
const slotChecked = ref('');
const conditionsResult = ref([]);
const hasFilter = computed(() => props.ruleForm.conditions?.[0]?.children?.length && (props.ruleForm.conditions?.[0]?.children.find((childrenItem) => childrenItem.field === props.col.colKey || (tools.isJSON(childrenItem.remark) && childrenItem.field + '.' + JSON.parse(childrenItem.remark)?.fieldKey === props.col.colKey))?.value || ['null', 'not_null'].includes(props.ruleForm.conditions?.[0]?.children.find((childrenItem) => childrenItem.field === props.col.colKey || (tools.isJSON(childrenItem.remark) && childrenItem.field + '.' + JSON.parse(childrenItem.remark)?.fieldKey === props.col.colKey))?.operation)));
// console.log(145, props.col, props.ruleForm.conditions, hasFilter.value);

const dateRangeType = ref('range');

const dateRangeTypeList = [
  {
    label: '日期区间',
    value: 'range'
  },
  {
    label: '开始时间',
    value: 'begin'
  },
  {
    label: '结束时间',
    value: 'end'
  }
];

const handleChangeDateRangeType = (value) => {
  dateRangeType.value = value;
  conditionsItem.value.operation = null;
  conditionsItem.value.value = null;
  conditionsResult.value = [];
};

//获取运算符
const getOperation = computed(() => {
  const fieldType = props.col?.fieldType !== 21 ? props.col?.fieldType : props.col?.business?.fieldType || null;

  const baseOptions = data.ruleForm?.filterType[fieldType] || [];

  if (fieldType === 10) {
    return baseOptions.filter((item) => !['in', 'not_in'].includes(item.value));
  }

  if (['begin', 'end'].includes(dateRangeType.value)) {
    // 日期范围 开始时间 结束时间 返回日期类型运算符
    return data.ruleForm?.filterType[8] || [];
  }

  return baseOptions;
});

const storage = {
  setItem(key, value) {
    if (key && value) {
      const v = JSON.stringify(value);
      localStorage.setItem(key, v);
      // console.log(29, value);
      return value;
    }
    return value;
  },
  getItem(key) {
    let v = localStorage.getItem(key);
    if (v !== 'null' && v !== undefined) {
      v = JSON.parse(v);
    }
    return v;
  },
  removeItem(key) {
    return localStorage.removeItem(key);
  }
};
// 点击更多图表标
const clickMoreIcon = () => {
  // 要存储到本地数据的列数据
  // 生成唯一key
  const uniqueKey = data.columns?.map((el) => el.colKey).join('') + data.columns?.length;
  // 保存默认列和实际列
  const tableKey = ref(`${CONFIG.prefix}TABLE_COLS_${uuid.value}_${md5(uniqueKey)}`);
  const defCols = data.columns?.reduce((prev, cur) => {
    const tmp = {};
    if (cur.width) tmp.width = cur.width;
    if (cur.fixed) tmp.fixed = cur.fixed;
    if (cur.colShow === false) tmp.colShow = cur.colShow;
    prev[cur.colKey] = tmp;
    return prev;
  }, {});
  const defColsSort = data.columns?.map((el) => el.colKey);
  // 默认列的值
  const kf = storage.getItem(tableKey.value) || { k: defCols, sort: defColsSort };
  const kfDef = storage.getItem(`${tableKey.value}_DEFAULT`) || { k: defCols, sort: defColsSort };
  console.log(64, data.columns, uuid.value, kf, kfDef);
  // 根据当前localStorage中的数据，生成新的columns
  const newColumns = data.columns.map((v) => {
    return {
      ...v,
      fixed: kf.k[v.colKey]?.fixed === 'left' ? 'left' : kf.k[v.colKey]?.fixed === 'right' ? 'right' : undefined,
      width: kf.k[v.colKey]?.width,
      colShow: kf.k[v.colKey]?.colShow
    };
  });
  console.log(126, newColumns);
  newColumns?.forEach((v) => {
    if (v.colKey === props.col.colKey) {
      slotChecked.value = kf.k[props.col.colKey].fixed === 'left';
    }
  });
  // 将新的columns保存起来，传递给父组件，让父组件更新Table组件
  const indexMap = {};
  kf.sort?.forEach((key, index) => {
    indexMap[key] = index;
  });
  newColumns.sort((a, b) => {
    const indexA = indexMap[a.colKey];
    const indexB = indexMap[b.colKey];
    if (indexA === undefined && indexB === undefined) return 0;
    if (indexA === undefined) return 1;
    if (indexB === undefined) return -1;
    return indexA - indexB;
  });
  cols.value = newColumns;
  data.visible = true;
  data.ruleForm = JSON.parse(JSON.stringify(props?.ruleForm || {}));
  conditionsResult.value = JSON.parse(JSON.stringify(data.ruleForm?.conditions || []));
  conditionsItem.value = (data.ruleForm.conditions?.[0]?.children?.length && data.ruleForm.conditions?.[0]?.children.find((childrenItem) => childrenItem.field === props.col.colKey || (tools.isJSON(childrenItem.remark) && childrenItem.field + '.' + JSON.parse(childrenItem.remark)?.fieldKey === props.col.colKey))) || {};
  // 保存打开时筛选项与退出时对比
  getConditions(); // 处理数据的val
  const oldcondtion = updateCondition(conditionsResult.value);
  if (oldcondtion && oldcondtion?.length) {
    data.oldConditionsItem = JSON.stringify(updateCondition(conditionsResult.value));
  }
  props.showLayCb(true, props.col.colKey);
};
// 初始化格式筛选value
const getConditions = async () => {
  // 处理数据设置setting
  await setConditionsFieldSetting(data.ruleForm.conditions);
  try {
    const conditions = data.ruleForm.conditions;
    if (!conditions || conditions.length == 0) {
      data.ruleForm.conditions = [];
      data.ruleForm.fieldKey = t('全部数据');
    } else if (conditions.length) {
      conditions?.forEach((item) => {
        item.children?.forEach((sub) => {
          if (isUserDepartment(sub) && (sub.operation != 'null' || sub.operation != 'not_null')) {
            sub.value = _.isString(sub.value) && sub?.business && Object.keys(sub?.business)?.length > 0 ? sub.business : sub.value;
            if (_.isString(sub.value) || _.isArray(sub.value)) {
              return false;
            }
            const dept = sub.value?.departIds?.map((v) => v.name) || [];
            const user = sub.value?.userIds?.map((v) => v.name) || [];
            const userIds = sub.value?.userIds?.map((v) => v.id) || [];
            const departIds = sub.value?.departIds?.map((v) => v.id) || [];
            // input框里回显数据
            sub.userIds = userIds;
            sub.departIds = departIds;
            sub.userDeptIds = [...userIds, ...departIds];
            sub.userDept = [...dept, ...user];
            sub.userList = sub.value?.userIds?.map((v) => {
              return {
                ...v,
                userName: v.name,
                avatarOrigin: v.avatar
              };
            });
            sub.departList = sub.value?.departIds?.map((v) => {
              return {
                ...v,
                departmentName: v.name,
                avatarOrigin: v.avatar
              };
            });
            sub.value = JSON.stringify({
              userIds: userIds,
              departIds: departIds
            });
          }
          if (sub.operation === 'in' || sub.operation === 'not_in') {
            if (_.isString(sub.value)) {
              if (isCascader(sub) && sub.value?.includes('/')) {
                sub.value = sub.value?.split(',')?.map((str) => str.split('/'));
              } else {
                sub.value = sub?.value?.split(',');
              }
            }
          } else if (props.fromPage === 'formula' && sub.operation === 'between') {
            // 在区间（日期类型）
            if (isDteTime(sub)) {
              const parsedObject = tools.isJSON(sub.value) && JSON.parse(sub.value) ? JSON.parse(sub.value) : '';
              sub.value = [parsedObject.beginDate, parsedObject.endDate];
            }
          } else if (isCascader(sub) && (sub.operation == 'equals' || sub.operation == 'not_equals')) {
            sub.value = sub.value && typeof sub.value === 'string' ? sub.value?.split('/') : sub?.value;
          } else if (sub.operation === 'between') {
            if (isDateRange(sub) && !['begin', 'end'].includes(sub.subProperty)) {
              const parsedObject = tools.isJSON(sub.value) && JSON.parse(sub.value) ? JSON.parse(sub.value) : '';
              sub.value = [parsedObject.beginDate, parsedObject.endDate];
            }
          } else {
            // 兼容一下日期类型的数据，如果返回的是数组就变成字符串
            sub.value = Array.isArray(sub.value) ? sub.value.join() : sub.value;
          }
          // 处理数字
          if (isNumber(sub) && sub.operation !== 'null' && sub.operation !== 'not_null') {
            if (sub.value && !isNaN(Number(sub.value))) sub.value = Number(sub.value);
          }
          // 处理价格
          if (isPrice(sub) && sub.operation !== 'null' && sub.operation !== 'not_null') {
            if (sub.value && !isNaN(Number(sub.value))) sub.value = Number(sub.value) / 10000;
          }
          // 处理百分比字段类型
          if (isPercentage(sub) && sub.operation != 'null' && sub.operation != 'not_null') {
            if (sub.value && !isNaN(Number(sub.value))) {
              let fieldExt = '';
              if (sub.setting.fieldType === 21) {
                if (sub.setting?.business?.fieldType === 24) {
                  fieldExt = (tools.isJSON(sub.setting?.business?.fieldExt) && JSON.parse(sub.setting?.business?.fieldExt)?.dataType) || 2;
                } else {
                  fieldExt = (tools.isJSON(sub.setting?.business?.fieldExt) && JSON.parse(sub.setting?.business?.fieldExt)?.numberFormat) || 2;
                }
              } else {
                if (sub.setting.fieldType === 24) {
                  fieldExt = (tools.isJSON(sub.setting?.fieldExt) && JSON.parse(sub.setting?.fieldExt)?.dataType) || 2;
                } else {
                  fieldExt = (tools.isJSON(sub.setting?.fieldExt) && JSON.parse(sub.setting?.fieldExt)?.numberFormat) || 2;
                }
              }
              sub.value = tools.getPercentage(sub.value, fieldExt);
            }
          }

          //特殊处理日期范围
          if (isDateRange(sub)) {
            if (['begin', 'end'].includes(sub.subProperty)) {
              dateRangeType.value = sub.subProperty;
            }
          }
        });
      });
      console.log(7361, conditions);
      data.ruleForm.conditions = conditions;
    }
  } catch (e) {
    console.log(e, '失败了');
  }
};

// 追加字段属性
const setConditionsFieldSetting = async (array) => {
  array?.forEach((item) => {
    item?.children?.forEach((el) => {
      const fieldObj = data.ruleForm.leadsFieldList?.find((sub) => sub?.fieldKey == el.field || sub.arr?.includes(el.field));
      if (fieldObj) {
        el.setting = fieldObj;
        if (fieldObj?.childSetting?.length) {
          fieldObj.childSetting.forEach((m) => {
            if (el.field?.split('.')?.[1] == m.fieldKey) {
              el.setting = m;
            }
          });
        }
      }
    });
  });
};
// 级联
const isCascader = (child) => {
  if (!child?.setting) return false;
  return child.setting.fieldType === 10 || child.setting?.business?.fieldType === 10;
};

// 日期 日期区间
const isDteTime = (child) => {
  if (!child?.setting) return false;
  return child.setting.fieldType === 8 || child.setting?.business?.fieldType === 8 || child.setting.fieldType === 9 || child.setting?.business?.fieldType === 9 || (child.setting.fieldType == 24 && tools.isJSON(child.setting.fieldExt) && [8]?.includes(JSON.parse(child.setting.fieldExt).type)) || (child.setting?.business?.fieldType == 24 && tools.isJSON(child.setting?.business?.fieldExt) && [8]?.includes(JSON.parse(child.setting?.business?.fieldExt).type));
};
// 日期区间
const isDateRange = (child) => {
  if (!child?.setting) return false;
  return child.setting.fieldType === 9 || child.setting?.business?.fieldType === 9;
};

// 数字
const isNumber = (child) => {
  if (!child?.setting) return false;
  return child.setting.fieldType === 7 || child.setting?.business?.fieldType === 7 || (child.setting.fieldType == 24 && tools.isJSON(child.setting.fieldExt) && [5, 7]?.includes(JSON.parse(child.setting.fieldExt).type)) || (child.setting?.business?.fieldType == 24 && tools.isJSON(child.setting?.business?.fieldExt) && [5, 7]?.includes(JSON.parse(child.setting?.business?.fieldExt).type));
};
// 金额
const isPrice = (child) => {
  if (!child?.setting) return false;
  return child.setting.fieldType === 16 || child.setting?.business?.fieldType === 16 || (child.setting.fieldType == 24 && tools.isJSON(child.setting.fieldExt) && [6, 16]?.includes(JSON.parse(child.setting.fieldExt).type)) || (child.setting?.business?.fieldType == 24 && tools.isJSON(child.setting?.business?.fieldExt) && [6, 16]?.includes(JSON.parse(child.setting?.business?.fieldExt).type));
};
// 百分比
const isPercentage = (child) => {
  if (!child?.setting) return false;
  return child.setting.fieldType === 23 || child.setting?.business?.fieldType === 23 || (child.setting.fieldType == 24 && tools.isJSON(child.setting.fieldExt) && [23]?.includes(JSON.parse(child.setting.fieldExt).type)) || (child.setting?.business?.fieldType == 24 && tools.isJSON(child.setting?.business?.fieldExt) && [23]?.includes(JSON.parse(child.setting?.business?.fieldExt).type));
};
// 人员部门
const isUserDepartment = (child) => {
  if (!child?.setting) return false;
  return child.setting.fieldType === 6 || child.setting?.business?.fieldType === 6 || child.setting.fieldType === 22 || child.setting?.business?.fieldType === 22;
};
const getsortData = ref();
const getFieldsSort = (col, fieldSortType = null, subProperty = null) => {
  if (props.isAssociation) {
    if (getsortData.value?.length) {
      const _obj = getsortData.value.find((item) => item.fieldKey == col.colKey);
      if (_obj && _obj.subProperty == subProperty && fieldSort.value === fieldSortType) {
        return true;
      }
    }
    return false;
  }
  if (useFilterList.fieldsSort?.length) {
    const _obj = useFilterList.fieldsSort.find((item) => item.fieldKey == col.colKey);
    if (_obj && _obj.subProperty == subProperty && fieldSort.value === fieldSortType) {
      return true;
    }
  }
  return false;
};

const getIsNotSort = () => {
  if (constFieldSort?.includes(props.col.fieldType) && props.col?.oldFieldType != 21) {
    return true;
  } else {
    return false;
  }
};

// 升序降序切换
const sortChange = (v, col = null, subProperty = null) => {
  const _obj = { fieldKey: props.col.colKey, fieldSort: v, fieldStatus: 1, isDefault: false };
  if (col.fieldType == 9) {
    if (subProperty) {
      _obj.subProperty = subProperty;
    } else {
      Message.warning('请选择开始时间或结束时间');
      return;
    }
  }
  data.visible = false;
  props.showLayCb(false, props.col.colKey);
  if (useFilterList.fieldsSort?.length >= 5) {
    Message.warning('排序最大支持5列');
    return;
  }
  data.sortChangeData.col = col;
  fieldSort.value = v;
  if (props.isAssociation) {
    const obj = { fieldKey: props.col.colKey, sort: v, fieldStatus: 1, isDefault: false, subProperty: col.fieldType == 9 ? subProperty : '', fieldType: col.fieldType };
    props.sortCb(obj);
    getsortData.value = [obj];
  } else {
    // 修改pinia
    useFilterList.setFieldsSort(_obj);
    props.sortCb();
  }
};
// 冻结按钮切换开关
const changeSwitch = (v) => {
  console.log(55, props.col.colKey, v, cols.value);
  slotChecked.value = v;
  // 将新的columns保存起来，传递给父组件，让父组件更新Table组件
  props.cb(props.col.colKey, v, cols.value);
  if (v) {
    // Message.success('该列已解冻');
    Message.success('该列已冻结');
  } else {
    Message.success('该列已取消冻结');
  }
  data.visible = false;
  props.showLayCb(false, props.col.colKey);
  const element = document.querySelector('.fh-table-header-popup-confirm');
  if (element) {
    element.style.display = 'none';
  }
};
// 获取条件下拉选择
const getConditionFilterType = (field) => {
  console.log(406, field);
  // data.filterType[data.objList[sub.field]?.fieldType != 21 ? data.objList[sub.field]?.fieldType : data.objList[sub.field]?.business?.fieldType]
  let list = [];
  const fieldType = data.ruleForm?.objList[field]?.fieldType;
  const drf = data.ruleForm?.filterType;
  const dro = data.ruleForm?.objList;
  if (fieldType == 21) {
    if (dro[field]?.business?.fieldType == 24) {
      const businessFieldExt = tools.isJSON(dro[field]?.business?.fieldExt) && JSON.parse(dro[field]?.business?.fieldExt);
      list = drf[dro[field]?.business?.fieldType][businessFieldExt?.type];
    } else {
      list = drf[dro[field]?.business?.fieldType];
    }
  } else {
    if (dro[field]?.fieldType == 24) {
      const fieldExt = tools.isJSON(dro[field]?.fieldExt) && JSON.parse(dro[field]?.fieldExt);
      list = drf[dro[field]?.fieldType][fieldExt?.type];
    } else {
      list = drf[dro[field]?.fieldType];
    }
  }
  console.log(332, drf, dro, list);
  return list;
};
// 第二个change事件
const changeChildTwo = (e, type) => {
  console.log('changeChildTwo', e, type);
  conditionsItem.value.value = undefined;
  const flp = conditionsItem.value;
  if (flp?.userDept || flp?.departList || flp?.userList || flp?.userIds || flp?.departIds || flp?.userDeptIds) {
    flp.userDept = [];
    flp.departList = [];
    flp.userList = [];
    flp.userIds = [];
    flp.departIds = [];
    flp.userDeptIds = [];
  }
  const arr = Object.values(data.ruleForm.filterType);
  arr?.forEach((item) => {
    // 对计算字段24的条件进行特殊处理
    item = Array.isArray(item) ? item : item[type];
    item?.forEach((i) => {
      if (i.value == e) {
        data.fieldTwo = i.label;
      }
    });
  });
  if (e === 'null' || e === 'not_null' || !e) updateModulesItem({ operation: e });
};

// 组装筛选参数
const updateModulesItem = (e) => {
  // 只改变value时不触发

  // debugger;
  if (!e.operation && e.value) {
    return;
  }
  const conditions = JSON.parse(JSON.stringify(data.ruleForm.conditions))?.length
    ? JSON.parse(JSON.stringify(data.ruleForm.conditions))
    : [
        {
          operation: 'and',
          isGroup: true,
          field: null,
          value: null,
          children: []
        }
      ];

  const parentColKey = props.col.colKey?.split('.')?.[0];
  const num = conditions?.[0]?.children.length ? conditions?.[0]?.children.findIndex((child) => parentColKey === child.field) : -1;
  if (num > -1) {
    if (e.value || ['null', 'not_null'].includes(e.operation)) {
      // 更改筛选项
      conditions[0].children[num] = Object.assign(conditions[0]?.children[num], e);
    } else {
      // 删除筛选项
      conditions[0]?.children.splice(num, 1);
    }

    //日期范围特殊处理
    if (props.col?.fieldType === 9) {
      conditions[0].children[num].subProperty = ['begin', 'end'].includes(dateRangeType.value) ? dateRangeType.value : null;
    }
  } else {
    if (!e.operation) {
      return;
    }
    conditions?.[0]?.children?.push(
      Object.assign(
        {
          field: props.col?.colKey,
          fieldType: props.col?.fieldType,
          subProperty: ['begin', 'end'].includes(dateRangeType.value) ? dateRangeType.value : null,

          isGroup: false
        },
        e
      )
    );
  }

  console.log('conditions', JSON.parse(JSON.stringify(conditions)));
  // 追加字段，调用父组件
  setConditionsFieldSetting(conditions);
  conditionsResult.value = conditions; // 处理数据
};

const updateCondition = (conditions) => {
  const arr = JSON.parse(JSON.stringify(conditions || []))?.filter((item) => item.children?.length);
  arr?.forEach((item) => {
    item.children?.forEach((child) => {
      console.log(509, child, props.col);
      if (child?.field?.split('.')?.length == 2) {
        //说明是子表单
        const subFieldObj = props.col?.setting?.find((b) => b.fieldKey === child.field?.split('.')[1]);
        if (subFieldObj) {
          console.log(5090, subFieldObj, child.field?.split('.')[1]);
          child.field = child.field?.split('.')[0];
          child['remark'] = tools.isJSON(child.remark) && tools.isJSON(child.remark)?.fieldKey ? child.remark : subFieldObj ? JSON.stringify({ entity: subFieldObj.entityId, fieldKey: subFieldObj?.fieldKey, settingId: subFieldObj.id }) : null;
        }
      }
      if (Array.isArray(child.value) && (child.operation === 'in' || child.operation === 'not_in')) {
        if (Array.isArray(child.value[0]) && isCascader(child)) {
          child.value = child.value?.map((subArr) => subArr.join('/')).join(',');
        } else {
          if (Array.isArray(child.value)) {
            child.value = child.value?.filter(Boolean).join(',');
          }
        }
      } else if (Array.isArray(child.value) && child.operation === 'between') {
        //只有日期，日期范围有‘between’操作符
        const obj = {
          beginDate: child.value[0],
          endDate: child.value[1]
        };
        child.value = JSON.stringify(obj);
      } else if ((Array.isArray(child.value) && child.operation === 'equals') || child.operation === 'not_equals') {
        if (isCascader(child) && Array.isArray(child.value)) {
          child.value = child.value.join('/');
        }
      }
      if (isPrice(child) && child.operation != 'null' && child.operation != 'not_null') {
        child.value = child.value * 10000;
      }
      if (isNumber(child) && child.operation != 'null' && child.operation != 'not_null') {
        child.value = Number(child.value);
      }
      // 处理百分比字段类型
      if (isPercentage(child) && child.operation != 'null' && child.operation != 'not_null') {
        if (child.value && !isNaN(Number(child.value))) {
          let fieldExt = '';
          if (child.setting.fieldType === 21) {
            if (child.setting?.business.fieldType === 24) {
              fieldExt = (tools.isJSON(child.setting?.business?.fieldExt) && JSON.parse(child.setting?.business?.fieldExt)?.dataType) || 2;
            } else {
              fieldExt = (tools.isJSON(child.setting?.business?.fieldExt) && JSON.parse(child.setting?.business?.fieldExt)?.numberFormat) || 2;
            }
          } else {
            if (child.setting.fieldType === 24) {
              fieldExt = (tools.isJSON(child.setting?.fieldExt) && JSON.parse(child.setting?.fieldExt)?.dataType) || 2;
            } else {
              fieldExt = (tools.isJSON(child.setting?.fieldExt) && JSON.parse(child.setting?.fieldExt)?.numberFormat) || 2;
            }
          }
          console.log(fieldExt);
          child.value = tools.setPercentage(child.value, fieldExt);
        }
      }
      // 处理人员字段类型
      if (isUserDepartment(child)) {
        if ((child.operation != 'null' || child.operation != 'not_null') && _.isObject(child.value)) {
          child.value = JSON.stringify({
            userIds: _.map(child.value.userIds, 'id'),
            departIds: _.map(child.value.departIds, 'id')
          });
        }
        if (props.fromPage === 'echart' && child?.userList?.length > 0) {
          //图表
          child.business.userIds = child.userList?.map((v) => {
            return {
              ...v,
              name: v.userName,
              avatar: v.avatarOrigin
            };
          });
        }
      }
      if (child.setting) delete child.setting;
    });
  });
  return arr;
};

watch(
  () => props.record?.fieldSort,
  (v) => {
    fieldSort.value = v;
  },
  {
    deep: true,
    immediate: true
  }
);
watch(
  () => props.showColOverlay,
  (v) => {
    if (!v && props.colOverlayId === props.col.colKey) {
      const newConditionsItem = updateCondition(conditionsResult.value);
      if (newConditionsItem?.length || data.oldConditionsItem != (newConditionsItem?.length ? JSON.stringify(newConditionsItem) : '')) {
        props.getSearchDataCb({ conditions: newConditionsItem, type: true });
      }
      data.visible = false;
    }
  },
  {
    // deep: true,
    // immediate: true
  }
);
</script>
<style scoped lang="less">
@import './ly-col-more.less';
</style>
